export const gaDownloadEvent = fileName => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'file_download',
    file_name: fileName
  });
};
